// @ts-strict-ignore
import { IOperation } from '@shared/undo/operation/i-operation';
import { PermissionsNavigationModel } from '@project/components/permissions/permissions-navigation.model';
import { ProjectNavigationModelState } from '@project-navigation/service/project-navigation-model-state';

export class PermissionsNavigationOperation implements IOperation {

  public get oldState(): ProjectNavigationModelState {
    return this._oldState;
  }

  public get newState(): ProjectNavigationModelState {
    return this._newState;
  }

  constructor(private model: PermissionsNavigationModel,
      private _oldState: ProjectNavigationModelState,
      private _newState: ProjectNavigationModelState) {
  }

  getQualifiedClassName(): string {
    return `PermissionNavigationOperation`;
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    this.changeState(this._newState);
  }

  public async performUndo(): Promise<void> {
    this.changeState(this._oldState);
  }

  private changeState(state: ProjectNavigationModelState): void {
    this.model.navigationChain = state.navigationChain;
    this.model.searchMode = state.searchMode;
    this.model.searchText = state.searchText || '';
    if (state.searchMode) {
      this.model.rootSearchProjectGroup = state.rootSearchProjectGroup;
    }
    this.model.currentProjectGroup = state.navigationChain[state.navigationChain.length - 1];
    this.model.currentSelectedItem = null;
    this.model.collapsedProjects = [];
  }
}
